import React from 'react';
import VerificationForm from '../components/Form/VerificationForm.tsx';

export default function InitialCheckForm() {
    return (
        <VerificationForm
            heading="Anmeldung zur Zentralprüfung"
            introContentTitle="Zentralprüfung Anmeldung"
            draftKey="initial-check"
        />
    )
}
